import { c as createSvgIcon } from '../../createSvgIcon-de76dc64.js';
import React from 'react';
import 'tslib';
import '@mui/material/SvgIcon';

var index = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("circle", { cx: "3", cy: "3", r: "3" }),
    React.createElement("circle", { cx: "3", cy: "12", r: "3" }),
    React.createElement("circle", { cx: "3", cy: "21", r: "3" }),
    React.createElement("circle", { cx: "21", cy: "3", r: "3" }),
    React.createElement("circle", { cx: "21", cy: "12", r: "3" }),
    React.createElement("circle", { cx: "21", cy: "21", r: "3" }),
    React.createElement("circle", { cx: "12", cy: "3", r: "3" }),
    React.createElement("circle", { cx: "12", cy: "12", r: "3" }),
    React.createElement("circle", { cx: "12", cy: "21", r: "3" })), 'AppSwitcher');

export { index as default };
